import { defineMessages, MessageDescriptor } from 'react-intl';

const msgs = defineMessages({
  firstSession: {
    id: 'blob_eos_subheader_first_session',
    defaultMessage: 'Great start! Here’s your progress so far.',
  },
  anotherSession: {
    id: 'blob_eos_subheader_another_session',
    defaultMessage: 'Another session complete! Here’s what you accomplished.',
  },
  niceWork: {
    id: 'blob_eos_subheader_nice_work',
    defaultMessage: 'Nice work! Take a look at what you’ve achieved.',
  },
  sessionDone: {
    id: 'blob_eos_subheader_session_done',
    defaultMessage: 'That’s another session done. Look what you’ve accomplished!',
  },
  makingProgress: {
    id: 'blob_eos_subheader_making_progress',
    defaultMessage: 'You’re making progress! Here’s what you worked on.',
  },
  underYourBelt: {
    id: 'blob_eos_subheader_under_your_belt',
    defaultMessage: 'One more session under your belt. Here’s how you did.',
  },
  greatWork: {
    id: 'blob_eos_subheader_great_work',
    defaultMessage: 'Great work! Here’s a little recap of your session.',
  },
});

export const SUBHEADER_POOL: MessageDescriptor[] = [
  msgs.anotherSession,
  msgs.niceWork,
  msgs.sessionDone,
  msgs.makingProgress,
  msgs.underYourBelt,
  msgs.greatWork,
];

export const pickSubheader = (isFirstSession: boolean, random: () => number): MessageDescriptor =>
  isFirstSession ? msgs.firstSession : SUBHEADER_POOL[Math.floor(random() * SUBHEADER_POOL.length)];
